import { pathOr } from 'ramda';
import { takeEvery, takeLatest, call, put } from 'redux-saga/effects';

import contactService from 'services/contactService';
import searchService from 'services/searchService';

import { accountSearch, fetchAccount, types } from './actions';

export default function* root() {
  yield takeLatest(types.ACCOUNT_SEARCH_REQUEST, watchAccountSearch);
  yield takeEvery(types.FETCH_ACCOUNT_REQUEST, watchFetchAccount);
}

function* watchAccountSearch(action) {
  const { search } = action.payload;
  try {
    const response = yield call(searchService.accounts, {
      query: search,
    });

    yield put(
      accountSearch.success({
        searchResults: pathOr([], ['results'], response),
      }),
    );
  } catch (error) {
    yield put(accountSearch.error(error));
  }
}

function* watchFetchAccount(action) {
  try {
    const { accountId } = action.payload;
    const account = yield call(contactService.accounts.get, accountId);
    yield put(fetchAccount.success({ account }));
  } catch (error) {
    console.error('Failed to fetch account.', error);
  }
}
